import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { NavLink } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import { IconLogoFull /*IconSocialFacebook, IconSocialMedium, IconSocialVK*/ } from '../svg'

import languages from '../i18n/languages'

import { COMMON__SET_LANGUAGE } from '../store/actions'

class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    handleClick__change_language = item => async evt => {
        evt.preventDefault()
        try {
            if (item.is_enabled) {
                const { P__COMMON__SET_LANGUAGE } = this.props
                await P__COMMON__SET_LANGUAGE(item.value)
                document.location.reload()
            }
        } catch (err) {
            console.error(err)
        }
    }

    render() {
        const { i18n, t } = this.props

        return (
            <footer id="footer">
                <div className="main">
                    <div className="wrap-box">
                        <div className="logo">
                            <IconLogoFull />
                        </div>
                        <article>
                            <div>{t('_components._footer.article_1')}</div>
                            <div>{t('_components._footer.article_2')}</div>
                        </article>
                        {/*<ul className="social">*/}
                        {/*    <li><a className="fb" target="_blank" rel="noopener noreferrer" href="https://facebook.com"><IconSocialFacebook/></a></li>*/}
                        {/*    <li><a className="md" target="_blank" rel="noopener noreferrer" href="https://medium.com"><IconSocialMedium/></a></li>*/}
                        {/*    <li><a className="vk" target="_blank" rel="noopener noreferrer" href="https://vk.com"><IconSocialVK/></a></li>*/}
                        {/*</ul>*/}
                        <ul className="links">
                            <li>
                                <div className="title">{t('_components._footer._nav._platform.title')}</div>
                                <ul>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/template-gallery">
                                            {t('_components._footer._nav._platform._links.template_gallery')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <a href="https://blog.interacty.me">
                                            {t('_components._footer._nav._platform._links.blog')}
                                        </a>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/how-it-works">
                                            {t('_components._footer._nav._platform._links.how_it_works')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/about">
                                            {t('_components._footer._nav._platform._links.about')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/contacts">
                                            {t('_components._footer._nav._platform._links.contacts')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/investors">
                                            {t('_components._footer._nav._platform._links.investors')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/memory-games-for-teachers">
                                            {t('For teachers')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/memory-games-for-business">
                                            {t('For business')}
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <div className="title">{t('_components._footer._nav._products.title')}</div>
                                <ul>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/instant-pages">
                                            {t('Interactive worksheets')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/trivia-quiz">
                                            {t('_components._footer._nav._products._links.trivia_quiz')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/memory-game">
                                            {t('_components._footer._nav._products._links.memory')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/before-after">
                                            {t('_components._footer._nav._products._links.before_after')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/timeline">
                                            {t('_components._footer._nav._products._links.timeline')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/cookies">
                                            {t('Fortune cookies')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/horoscope">
                                            {t('Horoscope')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/interactive-image">
                                            {t('_components._footer._nav._products._links.interactive-image')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/hidden-objects">
                                            {t('Hidden objects')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/rank-battle">
                                            {t('_components._footer._nav._products._links.rank_battle')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/photostory">
                                            {t('_components._footer._nav._products._links.photostory')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/quotes">
                                            {t('_components._footer._nav._products._links.quotes')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/products/personality-quiz">
                                            {t('_components._footer._nav._products._links.personality_quiz')}
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <div className="title">{t('_components._footer._nav._languages.title')}</div>
                                <ul>
                                    {languages
                                        .filter(el => el.is_visible)
                                        .map(el => {
                                            return (
                                                <li key={el.code}>
                                                    <span
                                                        className={`${i18n.language === el.value ? 'is-active ' : ''}${
                                                            el.is_enabled ? '' : 'is-disabled '
                                                        }${el.is_silent ? 'is-silent' : ''}`}
                                                        onClick={this.handleClick__change_language(el)}
                                                    >
                                                        {el.label}
                                                    </span>
                                                </li>
                                            )
                                        })}
                                </ul>
                            </li>
                            <li>
                                <div className="title">{t('_components._footer._nav._terms_of_service.title')}</div>
                                <ul>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/terms-of-use">
                                            {t('_common.terms_of_use')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/privacy-policy">
                                            {t('_common.privacy_policy')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/cookie-policy">
                                            {t('_common.cookie_policy')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="is-active" to="/data-processing-agreement">
                                            {t('_common.data_processing_agreement')}
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="down container-fluid">
                    © Interacty 2016 – 2021<span>&nbsp;|&nbsp;</span>v1.2.0
                </div>
            </footer>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    P__COMMON__SET_LANGUAGE: value => dispatch(COMMON__SET_LANGUAGE(value)),
})

export default compose(connect(null, mapDispatchToProps), withTranslation('translations'))(Footer)
